import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MeetingService } from '../../services/meeting.service';

@Component({
  selector: 'app-meeting-prelaunch',
  templateUrl: './meeting-prelaunch.component.html',
  styleUrls: ['./meeting-prelaunch.component.scss']
})
export class MeetingPrelaunchComponent {
  constructor(private router: Router, private meetingservice: MeetingService) {}
  loading: boolean;
  async setMeetingLink(msg){
  try{
    const pathParts = msg.split('/');
    const meetingId = pathParts[pathParts.length - 1];
    this.loading = true;
    let info = await this.meetingservice.getMeeting(meetingId).toPromise();
    if(info){
      let dict = {title: info.title, id: info.meetingId}
      localStorage.setItem("lastvcirclemeeting", JSON.stringify(dict));
      this.router.navigate([`/join/${meetingId}`]);
    }
  }
  catch(e){
      console.warn(e);
  }    
  finally{
    this.loading = false;
  }
}

getLastMeetingLink(){    
  try{
    let obj = localStorage.getItem("lastvcirclemeeting") ?? "";
    return JSON.parse(obj)['id'] ?? "";
  }
  catch{
    return "";
  }
}
}
